var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import FooterLinks, { LinkProps } from "../FooterLinks";
import React from 'react';
import { css, styled, mq } from "../../utils";
var StyledSimpleFooter = styled.footer(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    background: black;\n    justify-content: space-between;\n    align-items: center;\n    display: flex;\n    padding: 0 1rem;\n\n    span {\n      font-size: 12px;\n      margin: 0.5rem 0;\n    }\n\n    span:nth-of-type(2) {\n      visibility: hidden;\n    }\n\n    div {\n      margin: 0.5rem 0;\n    }\n\n    ", "\n  "], ["\n    color: ", ";\n    background: black;\n    justify-content: space-between;\n    align-items: center;\n    display: flex;\n    padding: 0 1rem;\n\n    span {\n      font-size: 12px;\n      margin: 0.5rem 0;\n    }\n\n    span:nth-of-type(2) {\n      visibility: hidden;\n    }\n\n    div {\n      margin: 0.5rem 0;\n    }\n\n    ",
        "\n  "])), colors.placeholder, mq({
        height: ['90px', '90px', '62px'],
        flexDirection: ['column-reverse', 'column-reverse', 'row'],
    }));
});
var SimpleFooter = function (_a) {
    var className = _a.className, copyright = _a.copyright, _b = _a.links, links = _b === void 0 ? [] : _b;
    return (React.createElement(StyledSimpleFooter, { className: className },
        copyright && React.createElement("span", null, copyright),
        links && React.createElement(FooterLinks, { links: links }),
        copyright && React.createElement("span", null, copyright)));
};
export default SimpleFooter;
var templateObject_1;
//# sourceMappingURL=SimpleFooter.js.map